import { createSelector } from 'reselect'

import { selectComposedReportState } from './selectComposedReportState'

export const selectAmplifyMembershipValue = createSelector(
  [selectComposedReportState],
  ({ amplifyMembership }) => amplifyMembership
)
